import React from 'react'
import {connect} from 'react-redux'
import {withRouter} from 'react-router-dom'


class Footer extends React.Component {



  componentDidMount(){

    //stop external links
    // Fix history

    let links =  this.refs.container.querySelectorAll('a')

    //console.log('links',links,typeof(links));
      // find internal links
      for(let i in links){
        //console.log(links[i].host, window.location.host);
        if(links[i].host===window.location.host){
          links[i].addEventListener('click',(e)=>{
              //e.preventDefault();
              //console.log("local link hi-jacked");
              //window.location.pathname = e.target.pathname;
              //history.go(e.target.pathname)
          })
        }
      }
  }


  render () {

      //console.log("Footer",this.props);

      let content = this.props.optionsData.data.footer

    return(
      <footer className="content-row" ref="container">
        <div className="col-container">
          <div className="col" >
                <span className="temp" dangerouslySetInnerHTML={{__html:content.column_1}} />
                  <div style={{marginTop:'-1em'}}>Get in touch:<br />
                  <a href="mailto:info@thefyzz.com">Send us an email</a></div>
          </div>
          <div className="col" dangerouslySetInnerHTML={{__html:content.column_2}}></div>
          <div className="col" dangerouslySetInnerHTML={{__html:content.column_3}}></div>
          <div className="col" dangerouslySetInnerHTML={{__html:content.column_4}}></div>
        </div>
        <div className="bottom-row">
            <div className="legal">&copy;The Fyzz Facility 2017 <span className="desktop-only">|</span> <a href="/disclaimer">Disclaimer</a></div>
            <div className="social-icons">
                {(this.props.optionsData.data.imdb)?
                    <a href={this.props.optionsData.data.imdb} className="imdb" target="blank" ></a>
                  : null
                }
                {(this.props.optionsData.data.twitter)?
                    <a href={this.props.optionsData.data.twitter} className="twitter" target="blank" ></a>
                  : null
                }
                {(this.props.optionsData.data.facebook)?
                    <a href={this.props.optionsData.data.facebook} className="facebook" target="blank" ></a>
                  : null
                }

                {(this.props.optionsData.data.linkedin)?
                    <a href={this.props.optionsData.data.linkedin} className="linkedin" target="blank" ></a>
                  : null
                }
            </div>
        </div>
      </footer>
    )
  }
}

const mapStateToProps = (state) =>{

  const optionsData = state.optionsData

    return{
      optionsData
    }


}

export default withRouter(connect(mapStateToProps)(Footer));



// WEBPACK FOOTER //
// ./src/modules/footer/Footer.js